<script setup lang="ts">
    import dayjs from 'dayjs';
    import { ScheduleCoachingFormTableColumn } from './ScheduleFormsTable.vue';
    import UserCell from './UserCell.vue';
    import { __ } from '@/js/stores/expressions';
    import IconButton from '../../IconButton.vue';
    import { PencilIcon, TrashIcon } from '@lucide/vue';
    import { IScheduledCoachJob } from '@/js/services/api/scheduleCoachingForm/types';

    defineProps<{
        column: ScheduleCoachingFormTableColumn['field'];
        data: IScheduledCoachJob;
        canEdit?: boolean;
        canDelete?: boolean;
        onDelete: (data: IScheduledCoachJob) => void;
        onEdit: (data: IScheduledCoachJob) => void;
    }>();
</script>
<template>
    <div class="h-10 flex items-center">
        <template v-if="column === 'title'">
            <div>
                <p class="text-body">
                    {{ data.title }}
                </p>
            </div>
        </template>
        <template v-else-if="column === 'createdAt'">
            <p class="text-body">
                {{ data.createdAt ? dayjs(data.createdAt).format('YYYY-MM-DD') : '' }}
            </p>
        </template>
        <template v-else-if="column === 'createdByUsername'">
            <UserCell v-if="data.createdByUsername" :label="data.createdByUsername" />
        </template>
        <template v-else-if="column === 'actions'">
            <div class="flex gap-3 items-center">
                <IconButton
                    v-if="canEdit"
                    size="size-6"
                    area-size="size-6"
                    :tooltip="__('edit')"
                    :aria-label="__('edit') + ' ' + data.title"
                    @click="() => onEdit(data)"
                >
                    <PencilIcon class="size-5" />
                </IconButton>
                <IconButton
                    v-if="canDelete"
                    size="size-6"
                    area-size="size-6"
                    :tooltip="__('delete')"
                    :aria-label="__('delete') + ' ' + data.title"
                    @click="() => onDelete(data)"
                >
                    <TrashIcon class="size-5" />
                </IconButton>
            </div>
        </template>
    </div>
</template>
